
namespace TabAurous.ProductDevelopment {

    @Serenity.Decorators.registerClass()
    export class PDQuotationGrid extends Serenity.EntityGrid<PDQuotationRow, any> {
        protected getColumnsKey() { return 'ProductDevelopment.Quotation'; }
        protected getDialogType() { return PDQuotationDialog; }
        protected getIdProperty() { return PDQuotationRow.idProperty; }
        protected getInsertPermission() { return PDQuotationRow.insertPermission; }
        protected getLocalTextPrefix() { return PDQuotationRow.localTextPrefix; }
        protected getService() { return PDQuotationService.baseUrl; }
        private rowSelection: Serenity.GridRowSelectionMixin;
        private autoSize;
        constructor(container: JQuery) {
            super(container);
            this.slickGrid.setOptions({ rowHeight: 30 });
        } 
        protected addButtonClick() {

            let now = new Date(); 
            var voucherNo = FormatHelper.GetVoucherNo(104);
            var userDefinition = Q.Authorization.userDefinition;
            this.editItem(<PDQuotationRow>{
                VoucherNo: voucherNo, 
                VoucherTypeId: 104,
                CompanyId:userDefinition.CompanyId,
                FinancialYearId: userDefinition.FinancialYearId,
                UserId: userDefinition.UserId,
                CurrencyId: userDefinition.CurrencyId,
                TransDate: now.toDateString()
            });
        }
        protected createSlickGrid(): Slick.Grid {
            let grid = super.createSlickGrid();
            this.autoSize = new Slick.AutoColumnSize();
            grid.registerPlugin(this.autoSize);


            return grid;
        }
        protected createToolbarExtensions() {
            super.createToolbarExtensions();
            this.rowSelection = new Serenity.GridRowSelectionMixin(this);
        }


        protected markupReady() {
            super.markupReady();
            if (this.autoSize != null) {
                this.autoSize.resizeAllColumns();
            }
        }
    }
}